import React from 'react';
import Box from '../Box/Box';
import Title4 from '../Title/Title4';
import { ActionImageIconButton } from '../IconButton';

import TModalHeader from './@types/TModalHeader';

const ModalHeader = ({ title, onClose, onBack }: TModalHeader) => (
  <Box as="div" parent="Modal" name="Header">
    <Box as="div" parent="Modal-Header" name="Button">
      {onBack && <ActionImageIconButton onClick={onBack} name="back" color="text-primary" ariaLabel="Back" />}
    </Box>
    {title && <Title4>{title}</Title4>}
    <Box as="div" parent="Modal-Header" name="Button">
      {onClose && <ActionImageIconButton onClick={onClose} name="close" color="text-primary" ariaLabel="Close" />}
    </Box>
  </Box>
);

export default ModalHeader;
